import { ButtonLink } from "@/components/button-link";
import { Logo } from "@/components/logo";
import config from "@/config";

const LINKS = [
	{ href: "#como-funciona", label: "Como funciona" },
	{ href: "#dia", label: "Recursos" },
	{ href: "#para-quem", label: "Para quem" },
	{ href: "#perguntas", label: "Perguntas" },
];

export function SiteHeader() {
	return (
		<header data-slot="site-header">
			<div data-slot="site-header-inner">
				<a data-slot="brand" href="#topo" aria-label="Obra Todo Dia, início">
					<Logo />
					<span data-slot="brand-name">Obra Todo Dia</span>
				</a>
				<nav data-slot="site-nav" aria-label="Seções">
					{LINKS.map((link) => (
						<a key={link.href} data-slot="site-nav-link" href={link.href}>
							{link.label}
						</a>
					))}
					<ButtonLink size="sm" href={config.app.waitlistURL}>
						Entrar na lista de espera
					</ButtonLink>
				</nav>
			</div>
		</header>
	);
}
